import { status } from 'skin/event/status';
import dt from './data';
import master from './master';

const parList = (obj, ms, story, data, d, action) => {
	console.log('[Партнерские товары - Мастер] событие', obj);
	switch (obj.type) {
		case 'data':
			return dt(obj, ms, story, data, d, action);
		case 'master':
			return master(obj, ms, story, data, d, action);
		default:
			return status.action;
	}
};

export default parList;
